// ---------------------------------------------------------------
// PrivacyGate.js — Aviso de privacidad al entrar.
// Sale una vez por persona (y otra vez si el texto cambia de
// versión). Se guarda qué versión leyó y cuándo, para poder
// demostrar qué información se le dio a cada uno.
// Después queda siempre a mano en Mi perfil.
// ---------------------------------------------------------------
import { useEffect, useState } from "react";
import {
  subscribePrivacyAck,
  ackPrivacy,
} from "../services/privacyService";
import {
  PRIVACY_VERSION,
  PRIVACY_TITLE,
  PRIVACY_INTRO,
  PRIVACY_SECTIONS,
} from "../utils/privacyNotice";
import Icon from "./ui/Icon";

/** El texto del aviso, reutilizable dentro de Mi perfil */
export function PrivacyBody() {
  return (
    <>
      <p className="privacy-intro">{PRIVACY_INTRO}</p>
      <div className="privacy-sections">
        {PRIVACY_SECTIONS.map((s) => (
          <div key={s.title} className="privacy-block">
            <span className="privacy-icon">
              <Icon name={s.icon} size={17} />
            </span>
            <div>
              <h4>{s.title}</h4>
              <p>{s.body}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default function PrivacyGate({ user, profile, children }) {
  const [ack, setAck] = useState(undefined); // undefined = cargando
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(
    () =>
      subscribePrivacyAck(user?.uid, setAck, (e) => {
        console.error("Error leyendo el aviso:", e);
        // Si no se puede comprobar, no se bloquea la web: sería peor
        // dejar a la gente fuera por un fallo de red.
        setAck(null);
      }),
    [user?.uid]
  );

  if (ack === undefined) return children;
  if (ack && (ack.version || 0) >= PRIVACY_VERSION) return children;

  const aceptar = async () => {
    setGuardando(true);
    setError("");
    try {
      await ackPrivacy(user.uid, profile?.username || profile?.displayName);
    } catch (err) {
      console.error(err);
      setError("No se pudo guardar (¿reglas publicadas?).");
      setGuardando(false);
    }
  };

  return (
    <div className="privacy-gate">
      <div className="card privacy-card">
        <div className="privacy-head">
          <span className="consent-icon">
            <Icon name="shield" size={28} />
          </span>
          <div>
            <h2 className="privacy-title">{PRIVACY_TITLE}</h2>
            <p className="card-sub" style={{ margin: 0 }}>
              Léelo una vez. Después lo tienes siempre en Mi perfil.
            </p>
          </div>
        </div>

        <PrivacyBody />

        {error && <div className="modal-error">{error}</div>}

        <button
          className="btn-primary privacy-btn"
          onClick={aceptar}
          disabled={guardando}
        >
          {guardando ? "Guardando…" : "Entendido, continuar"}
        </button>
        <p className="privacy-foot">
          Al continuar queda registrado que has leído esta información
          (versión {PRIVACY_VERSION}) y la fecha. No es un consentimiento:
          es información que la farmacia tiene que darte.
        </p>
      </div>
    </div>
  );
}
